//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AwesomeMask from 'awesome-mask';
import { getClosestVueParent } from '../common/functions/helpers';

export default {
  name: 'InputMoneyOld',
  props: {
    oneWayBind: Number,
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    maxlength: [Number, String],
    placeholder: String,
    inputClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      valor: 0.0,
      lastHit: null,
      parentContainer: null,
    };
  },
  watch: {
    oneWayBind(novoValor) {
      if (this.lastHit === novoValor || novoValor === undefined) return;

      const event = new Event('keyup', { bubbles: true });
      this.$el.value = this.trataPerdaPrecisao(novoValor);
      this.$el.dispatchEvent(event);

      this.lastHit = novoValor;
    },
  },
  methods: {
    alteracao() {
      const valorAlterado = this.valorSemMascara();
      if (valorAlterado === this.lastHit) return;

      this.lastHit = valorAlterado;
      this.$emit('change', this.lastHit);
      this.setParentValue(valorAlterado);
    },
    consequencia() {
      this.$emit('blur', this.lastHit);
    },
    valorSemMascara() {
      return typeof this.valor === 'string' ?
        parseInt(this.valor.replace(/[\D]+/g, ''), 10) / 100 :
        this.valor;
    },
    trataPerdaPrecisao(novoValor) {
      let retorno = 0;
      const copia = novoValor * 10;
      if (novoValor - parseInt(novoValor, 10) === 0 || copia - parseInt(copia, 10) === 0) {
        retorno = novoValor * 100;
      } else {
        retorno = novoValor;
      }
      return parseFloat(retorno.toFixed(2));
    },
    setParentValue(value) {
      if (value === undefined || value === null) {
        this.parentContainer.setValue(this.$refs.input.value);
      } else {
        this.parentContainer.setValue(value);
      }
    },
    setParentDisabled() {
      this.parentContainer.isDisabled = this.disabled;
    },
    setParentRequired() {
      this.parentContainer.isRequired = this.required;
    },
    setParentPlaceholder() {
      this.parentContainer.hasPlaceholder = !!this.placeholder;
    },
    setParentUpdateValue(value) {
      this.setParentValue(value);
      this.updateValues(value);
    },
    updateValues(value) {
      const newValue = value || this.$refs.input.value || this.value;

      this.setParentValue(newValue);
      this.parentContainer.inputLength = newValue ? newValue.length : 0;
    },
  },
  directives: {
    mask: AwesomeMask,
  },
  beforeMount() {
    this.valor = this.trataPerdaPrecisao(this.oneWayBind || 0.0);
  },
  mounted() {
    this.parentContainer = getClosestVueParent(this.$parent, 'md-input-container');
  },
};



// WEBPACK FOOTER //
// ./src/shared-components/InputMoneyOld.vue?vue&type=script&lang=js&